import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import { SecureStorageService } from '../services/secure-storage.service';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private secureStorageService:SecureStorageService,
    private authService:AuthService,
  ){}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): 
    Observable<HttpEvent<unknown>> {
      let cloneRequest = request;

      const user = this.authService.getUserToken();

      if(user){
        cloneRequest = request.clone({
          setHeaders:{
            "X-Api-Key": environment.xApiKey,
          },
          // body: this.secureStorageService.encriptBase64(this.secureStorageService.encrypt(JSON.stringify(request.body)))  
        })
      }
      return next.handle(cloneRequest)   
  }
}
